module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/High_Stakes2#Contents-A"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Copyright © 2014 by John McEvoy")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("First E-book Edition  2014")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("ISBN: 9781464202773 ebook")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in, or introduced into a retrieval system, or transmitted in any form, or by any means (electronic, mechanical, photocopying, recording, or otherwise) without the prior written permission of both the copyright owner and the publisher of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("The historical characters and events portrayed in this book are inventions of the author or used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Poisoned Pen Press"), _c('br'), _vm._v("6962 E. First Ave., Ste. 103"), _c('br'), _vm._v("Scottsdale, AZ 85251")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright para-style-override-2"
  }, [_c('a', {
    attrs: {
      "href": "http://www.poisonedpenpress.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "Hyperlink",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("www.poisonedpenpress.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_c('a', {
    attrs: {
      "href": "mailto:info%40poisonedpenpress.com?subject="
    }
  }, [_c('span', {
    staticClass: "Hyperlink",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("info@poisonedpenpress.com")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5003aff8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/High_Stakes-1.vue
// module id = 63
// module chunks = 0